import * as React from "react";
import { cn } from "@/lib/utils";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "default" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
};

function Button({ className, variant = "default", size = "md", ...props }: ButtonProps) {
  const variants: Record<string, string> = {
    default: "bg-gradient-to-r from-pink-500 via-rose-500 to-orange-500 text-white hover:from-pink-600 hover:via-rose-600 hover:to-orange-600",
    outline: "border border-white/10 text-white bg-transparent hover:bg-white/10",
    ghost: "text-white bg-transparent hover:bg-white/10",
  };
  const sizes: Record<string, string> = {
    sm: "h-9 px-3 rounded-lg text-sm",
    md: "h-11 px-4 rounded-xl",
    lg: "h-14 px-6 rounded-2xl text-lg",
  };
  return <button className={cn("inline-flex items-center justify-center font-medium transition-colors", variants[variant], sizes[size], className)} {...props} />;
}

export { Button };
